import React from 'react';
import { RHTextField } from '../../../../../../../dum';
import { IProduct } from '../../product-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function CodeInput() {
    const inputName: keyof IProduct = 'code';

    return (
        <RHTextField name={inputName} label={shortLabel(FIELD_LABELS.code)} />
    );
}
